import { type FC } from "react";

import { SuggestionCriteriaForm } from "@pages/QASettings/SuggestionCriteriaForm";

interface BaseCriteriaCardProps {
  criteria: {
    id: string;
    name: string;
    category: string;
    content: string;
  };
  onNameSave: (id: string, name: string) => Promise<void>;
  onContentSave: (id: string, content: string) => Promise<void>;
  onCategorySave: (id: string, category: string) => Promise<void>;
}

export const BaseCriteriaCard: FC<BaseCriteriaCardProps> = ({
  criteria,
  onNameSave,
  onContentSave,
  onCategorySave,
}) => {
  return (
    <div className="w-full rounded-lg border border-gray-200 bg-white p-6 shadow-xs">
      <SuggestionCriteriaForm
        criteria={criteria}
        onNameSave={(name) => onNameSave(criteria.id, name)}
        onContentSave={(content) => onContentSave(criteria.id, content)}
        onCategorySave={(category) => onCategorySave(criteria.id, category)}
      />
    </div>
  );
};
